import { findIndex, isEmpty } from 'lodash';

import { answer, getQuestion, markQuestion } from '../../global/service';

import * as constants from './Question.constants';
//import * as services from './Question.service';

const state = {
  question: {
    detail: {},
  },
};

const mutations = {
  [constants.GET_QUESTION_SUCCESS](state, payload) {
    const { question, subQuestionId } = payload;
    if (isEmpty(question)) {
      state.question = question;
    } else {
      /* let isLatest = false;
      if (question.questionId === last(state.QuestionList).questionId) {
        isLatest = true;
      } */
      state.question = {
        ...question,
        // isAnswered: false,
        isAnswered: false,
        isSubmitted: false,
        // answer: question.answer && question.answer.toLowerCase(),
        // studentAnswer: question.studentAnswer && question.studentAnswer.toLowerCase(),
        isLatest: true,
        selectedOption: '', //: question.questionType.indexOf('QA') !== -1 ? 'done' : '',
      };
      if (question.qType === 'xl') {
        const subQuestions = question.subQuestions;
        state.question = {
          ...state.question,
          isInSubQuestions: true,
          pos: findIndex(subQuestions, (q) => q.questionId === subQuestionId),
          subQuestions: subQuestions.map((v, i) => ({
            ...v,
            // isAnswered: false,
            isAnswered: false,
            isSubmitted: false,
            selectedOption: '', //: v.questionType.indexOf('QA') !== -1 ? 'done' : '',
            // answer: v.answer && v.answer.toLowerCase(),
            isLatest: i === subQuestions.length - 1,
          })),
        };
      }
    }
    // console.log(state.question);
  },

  [constants.QUESTION_SUBMITTED_SUCCESS](state) {
    if (state.question.qType !== 'xl') {
      state.question = { ...state.question, isSubmitted: true };
      // console.log(state.question);
    } else {
      const subQuestions = state.question.subQuestions;
      const question = subQuestions[state.question.pos];
      question.isSubmitted = true;
    }
  },

  [constants.ANSWER_SUCCESS](state, { questionStatus }) {
    const deltaCorrectCount = questionStatus === 1 ? 1 : 0;
    const deltaWrongCount = questionStatus === 1 ? 0 : 1;
    if (state.question.qType !== 'xl') {
      state.question = {
        ...state.question,
        isAnswered: true,
        correctCount: state.question.correctCount + deltaCorrectCount,
        wrongCount: state.question.wrongCount + deltaWrongCount,
        personalCorrectCount: state.question.personalCorrectCount + deltaCorrectCount,
        personalWrongCount: state.question.personalWrongCount + deltaWrongCount,
      };
      const idx = findIndex(state.QuestionList, { questionId: state.question.questionId });
      if (idx != -1) {
        state.QuestionList[idx].questionStatus = questionStatus;
      }
    } else {
      const subQuestions = state.question.subQuestions;
      const question = subQuestions[state.question.pos];
      question.isAnswered = true;
      question.isCorrect = questionStatus === 1 ? true : false;
      question.correctCount = question.correctCount + deltaCorrectCount;
      question.wrongCount = question.wrongCount + deltaWrongCount;
      question.personalCorrectCount = question.personalCorrectCount + deltaCorrectCount;
      question.personalWrongCount = question.personalWrongCount + deltaWrongCount;
      const nonAnsweredArr = subQuestions.filter((v) => v.isAnswered === false);
      const isCorrectArr = subQuestions.filter((v) => !v.isCorrect);
      if (nonAnsweredArr.length === 0) {
        state.question = {
          ...state.question,
          isAnswered: true,
        };
      }
      const idx = findIndex(state.QuestionList, { questionId: state.question.questionId });
      if (idx != -1 && nonAnsweredArr.length === 0) {
        if (isCorrectArr.length === 0) {
          state.QuestionList[idx].questionStatus = 1;
        } else {
          state.QuestionList[idx].questionStatus = -1;
        }
      }
    }
  },

  [constants.SET_QUESTION](state, payload) {
    if (state.question.qType !== 'xl') {
      state.question = {
        ...state.question,
        ...payload,
      };
    } else {
      const { selectedOption } = payload;
      if (selectedOption) {
        state.question.subQuestions[state.question.pos].selectedOption = selectedOption;
      } else {
        state.question = {
          ...state.question,
          ...payload,
        };
      }
    }
  },

  [constants.MARK_QUESTION_SUCCESS](state, isMarked) {
    if (state.question.qType !== 'xl' || !state.question.isInSubQuestions) {
      state.question = {
        ...state.question,
        isMarked,
      };
    } else {
      const question = state.question.subQuestions[state.question.pos];
      question.isMarked = isMarked;
    }
  },
};

const actions = {
  async getQuestion({ commit }, payload) {
    const res = await getQuestion(payload.courseId, payload.questionId);
    commit(constants.GET_QUESTION_SUCCESS, {
      question: res.data.data,
      subQuestionId: payload.subQuestionId,
    });
  },

  async answer({ commit, state }, payload) {
    let param = {};
    if (state.question.qType !== 'xl') {
      if (state.question.questionType.indexOf('OP') !== -1) {
        param = {
          ...payload,
          questionId: state.question.questionId,
          questionStatus: state.question.answer === state.question.selectedOption ? 1 : -1,
          studentAnswer: state.question.selectedOption,
        };
      } else if (state.question.questionType.indexOf('QA') !== -1) {
        param = {
          ...payload,
          questionId: state.question.questionId,
          questionStatus: 1,
          //studentAnswer: 'done',
        };
      }
    } else {
      const question = state.question.subQuestions[state.question.pos];
      if (question.questionType.indexOf('OP') !== -1) {
        param = {
          ...payload,
          questionId: question.questionId,
          questionStatus: question.answer === question.selectedOption ? 1 : -1,
          studentAnswer: question.selectedOption,
        };
      } else if (question.questionType.indexOf('QA') !== -1) {
        param = {
          ...payload,
          questionId: question.questionId,
          questionStatus: 1,
          //studentAnswer: 'done',
        };
      }
    }
    commit(constants.ANSWER_SUCCESS, param);
    await answer(param);
    commit(constants.QUESTION_SUBMITTED_SUCCESS);
  },

  setQuestion({ commit }, payload) {
    commit(constants.SET_QUESTION, payload);
  },

  async markQuestion({ commit }, { courseId }) {
    let param = {};
    if (state.question.qType !== 'xl' || !state.question.isInSubQuestions) {
      param = {
        markStatus: !state.question.isMarked,
        isMark: state.question.isMarked ? 0 : 1,
        questionId: state.question.questionId,
        _type: 0,
        courseId,
      };
    } else {
      const question = state.question.subQuestions[state.question.pos];
      param = {
        markStatus: !question.isMarked,
        isMark: question.isMarked ? 0 : 1,
        questionId: question.questionId,
        _type: 0,
        courseId,
      };
    }
    const res = await markQuestion(param);
    if (res.data.status == 200) {
      commit(constants.MARK_QUESTION_SUCCESS, param.markStatus);
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
